var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokerCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 683,
    viewBox: "0 0 787 683",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.2445,
    y: 89.9093,
    width: 351.104,
    height: 541.569,
    rx: 17.3693,
    transform: "rotate(-10.3406 42.2445 89.9093)",
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.187,
    y: 141.033,
    width: 223.975,
    height: 414.44,
    rx: 11.9129,
    transform: "rotate(-10.3406 116.187 141.033)",
    fill: "#20C997",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.231 378.549L227.807 378.079L229.673 358.218L224.128 339.986L214.764 347.018L208.959 350.462L203.213 353.008L199.061 354.875L196.111 357.243L194.859 360.411L211.722 382.622L215.712 380.785L221.152 379.293L225.231 378.549Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.526 299.409L301.128 302.677L294.519 265.068L300.27 264.019L312.238 261.013L318.805 257.16L330.467 280.192L330.485 282.718L329.241 285.6L327.106 287.064L324.081 288.501L318.003 291.569L310.608 295.384L305.526 299.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.248,
    y: 245.373,
    width: 10.9214,
    height: 32.3296,
    rx: 1.34527,
    transform: "rotate(-11.5486 317.248 245.373)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.896844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.17,
    y: 239.039,
    width: 14.6635,
    height: 3.01437,
    rx: 1.34527,
    transform: "rotate(-11.5486 314.17 239.039)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.896844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.967,
    y: 248.887,
    width: 10.9214,
    height: 3.63907,
    transform: "rotate(-11.5486 317.967 248.887)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.896844
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.186,
    y: 241.659,
    width: 8.0239,
    height: 3.03439,
    transform: "rotate(-11.5486 318.186 241.659)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.658905
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.793 94.4999C287.314 92.1549 288.827 89.8655 291.172 89.3863C293.517 88.9071 295.806 90.4197 296.285 92.7647L325.6 236.224L317.107 237.96L287.793 94.4999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.793 94.4999C287.314 92.1549 288.827 89.8655 291.172 89.3863C293.517 88.9071 295.806 90.4197 296.285 92.7647L325.6 236.224L317.107 237.96L287.793 94.4999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.205 269.18C329.205 269.18 332.836 268.749 334.683 266.652C334.683 266.652 335.262 264.625 334.491 261.842C333.737 259.11 332.432 257.848 332.432 257.848C328.213 262.323 320.521 264.849 320.521 264.849L319.548 270.403L329.205 269.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.842 267.704C333.842 267.704 335.942 267.95 337.228 271.931C338.048 274.47 337.18 276.355 337.18 276.355C337.18 276.355 334.604 275.28 328.459 275.331C323.497 275.373 320.522 275.916 320.522 275.916C316.953 275.931 314.406 271.125 314.406 271.125C314.406 271.125 323.981 269.808 328.103 269.38C331.844 268.993 333.842 267.704 333.842 267.704Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.587 277.202C336.587 277.202 337.215 278.753 336.105 280.204C334.308 282.551 332.375 283.18 332.375 283.18C327.384 279.379 321.402 279.502 321.402 279.502C321.402 279.502 317.581 277.799 318.67 276.262L320.522 275.924C320.526 275.92 333.156 273.883 336.587 277.202Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.237 302.09C319.367 286.789 329.256 290.349 330.444 282.174",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.378 264.633C291.378 264.633 297.448 266.03 313.022 260.443",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.283 258.767C313.283 258.767 314.853 258.594 316.165 258.123C317.714 257.569 319.07 256.754 319.07 256.754C321.447 262.475 322.83 269.629 323.414 275.251C323.414 275.251 321.29 275.521 319.68 273.942C314.51 268.873 312.199 259.674 313.283 258.767Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.953 315.891C275.953 315.891 277.145 318.053 279.6 318.043C282.054 318.028 288.153 316.975 290.306 316.112C292.077 315.401 292.361 312.61 292.361 312.61",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.953 315.891C275.953 315.891 277.145 318.053 279.6 318.043C282.054 318.028 288.153 316.975 290.306 316.112C292.077 315.401 292.361 312.61 292.361 312.61",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.016 322.52C232.016 322.52 233.672 325.253 236.126 325.238C238.581 325.224 244.701 324.289 246.854 323.427C248.625 322.716 248.829 320.062 248.829 320.062",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.016 322.52C232.016 322.52 233.672 325.253 236.126 325.238C238.581 325.224 244.701 324.289 246.854 323.427C248.625 322.716 248.829 320.062 248.829 320.062",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.469 317.957C247.062 320.116 226.209 322.918 222.494 323.345C217.878 323.878 212.263 315.489 210.15 305.355C206.19 286.349 202.297 267.113 210.387 256.739C219.055 245.617 228.634 242.629 246.166 239.585C261.05 236.997 276.834 235.79 288.223 245.395C297.682 253.369 300.931 274.145 301.924 285.833C303.11 299.802 302.203 309.95 297.418 311.202C292.631 312.449 278.764 315.367 261.469 317.957Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.03 238.149C255.03 238.149 257.834 235.358 258.043 233.806C258.253 232.255 257.853 231.339 257.853 231.339",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.012 237.349C258.012 237.349 258.831 235.818 260.627 234.169C261.556 233.315 262.783 232.873 262.783 232.873",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.098 259.082L304.482 252.182",
    stroke: "black",
    strokeWidth: 2.24211,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.684 265.363L248.68 260.799",
    stroke: "black",
    strokeWidth: 2.24211,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.863 252.423L305.209 271.604L263.417 277.11",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.174 279.417L200.902 284.71L198.685 265.364",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.475 265.493C228.521 267.645 225.858 270.187 222.284 270.511C218.711 270.835 215.715 268.806 215.537 266.66C215.232 262.987 218.337 263.118 221.912 262.798C225.486 262.479 228.398 261.897 228.475 265.493Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.588 257.739C287.635 259.892 284.972 262.433 281.398 262.757C277.824 263.081 274.828 261.052 274.651 258.906C274.345 255.233 277.45 255.364 281.025 255.044C284.595 254.721 287.516 254.143 287.588 257.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.574 268.158C252.835 268.147 250.022 268.542 247.887 269.633C246.186 270.5 245.281 271.736 245.281 271.736C249.795 281.287 254.612 282.728 254.612 282.728C254.612 282.728 261.243 276.304 259.614 270.124",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.268,
    y: 397.106,
    width: 10.9214,
    height: 32.3296,
    rx: 1.34527,
    transform: "rotate(168.451 208.268 397.106)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.896844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.346,
    y: 403.439,
    width: 14.6635,
    height: 3.01437,
    rx: 1.34527,
    transform: "rotate(168.451 211.346 403.439)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.896844,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.549,
    y: 393.592,
    width: 10.9214,
    height: 3.63907,
    transform: "rotate(168.451 207.549 393.592)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.896844
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.33,
    y: 400.819,
    width: 8.0239,
    height: 3.03439,
    transform: "rotate(168.451 207.33 400.819)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.658905
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.722 547.979C238.201 550.324 236.689 552.613 234.344 553.092C231.999 553.571 229.709 552.059 229.23 549.714L199.916 406.254L208.408 404.519L237.722 547.979Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.722 547.979C238.201 550.324 236.689 552.613 234.344 553.092C231.999 553.571 229.709 552.059 229.23 549.714L199.916 406.254L208.408 404.519L237.722 547.979Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.311 373.3C196.311 373.3 192.68 373.732 190.833 375.828C190.833 375.828 190.254 377.856 191.025 380.638C191.779 383.371 193.084 384.633 193.084 384.633C197.302 380.157 204.994 377.631 204.994 377.631L205.968 372.078L196.311 373.3Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.673 374.776C191.673 374.776 189.573 374.531 188.287 370.549C187.467 368.011 188.336 366.125 188.336 366.125C188.336 366.125 190.911 367.2 197.056 367.149C202.019 367.107 204.993 366.565 204.993 366.565C208.562 366.55 211.109 371.355 211.109 371.355C211.109 371.355 201.535 372.673 197.412 373.101C193.672 373.487 191.673 374.776 191.673 374.776Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.929 365.279C188.929 365.279 188.301 363.727 189.411 362.276C191.208 359.929 193.141 359.301 193.141 359.301C198.132 363.101 204.114 362.979 204.114 362.979C204.114 362.979 207.935 364.681 206.845 366.218L204.993 366.556C204.99 366.561 192.36 368.598 188.929 365.279Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.279 340.391C206.148 355.691 196.26 352.131 195.072 360.306",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.137 377.848C234.137 377.848 228.068 376.451 212.494 382.037",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.233 383.714C212.233 383.714 210.663 383.887 209.35 384.357C207.801 384.911 206.446 385.726 206.446 385.726C204.068 380.006 202.686 372.851 202.102 367.229C202.102 367.229 204.226 366.959 205.836 368.539C211.005 373.608 213.316 382.807 212.233 383.714Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.1965,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.563 326.587C249.563 326.587 248.37 324.425 245.915 324.436C243.461 324.451 237.363 325.504 235.209 326.366C233.438 327.077 233.154 329.868 233.154 329.868",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.563 326.587C249.563 326.587 248.37 324.425 245.915 324.436C243.461 324.451 237.363 325.504 235.209 326.366C233.438 327.077 233.154 329.868 233.154 329.868",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5 319.959C293.5 319.959 291.843 317.225 289.389 317.24C286.935 317.255 280.815 318.189 278.661 319.052C276.89 319.762 276.686 322.416 276.686 322.416",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5 319.959C293.5 319.959 291.843 317.225 289.389 317.24C286.935 317.255 280.815 318.189 278.661 319.052C276.89 319.762 276.686 322.416 276.686 322.416",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.047 324.521C278.454 322.362 299.307 319.56 303.021 319.133C307.638 318.601 313.252 326.989 315.366 337.124C319.326 356.129 323.219 375.366 315.129 385.74C306.46 396.862 296.881 399.85 279.35 402.893C264.465 405.482 248.681 406.689 237.293 397.084C227.834 389.11 224.585 368.334 223.592 356.645C222.406 342.676 223.312 332.528 228.098 331.277C232.884 330.03 246.752 327.112 264.047 324.521Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.486 404.33C270.486 404.33 267.681 407.121 267.472 408.672C267.263 410.224 267.663 411.14 267.663 411.14",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.504 405.13C267.504 405.13 266.685 406.66 264.889 408.31C263.96 409.163 262.732 409.606 262.732 409.606",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.418 383.396L221.034 390.296",
    stroke: "black",
    strokeWidth: 2.24211,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.832 377.115L276.836 381.679",
    stroke: "black",
    strokeWidth: 2.24211,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.653 390.056L220.306 370.874L262.099 365.368",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.342 363.061L324.614 357.768L326.831 377.115",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.04 376.985C296.994 374.833 299.657 372.291 303.231 371.967C306.805 371.644 309.801 373.672 309.978 375.819C310.284 379.492 307.178 379.361 303.604 379.68C300.029 380 297.118 380.581 297.04 376.985Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.927 384.739C237.881 382.587 240.544 380.045 244.118 379.721C247.692 379.397 250.688 381.426 250.865 383.573C251.17 387.246 248.065 387.115 244.491 387.434C240.921 387.757 238 388.336 237.927 384.739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.942 374.321C272.68 374.332 275.494 373.937 277.628 372.845C279.33 371.979 280.235 370.742 280.235 370.742C275.721 361.192 270.904 359.75 270.904 359.75C270.904 359.75 264.273 366.175 265.902 372.355",
    stroke: "black",
    strokeWidth: 1.34527,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2722 194.584C108.749 199.981 118.06 183.357 106.363 174.538C106.363 174.538 89.4085 163.962 88.94 161.394C89.4116 163.979 77.2813 179.845 77.2813 179.845C69.4776 192.194 83.9467 204.417 92.7855 195.471C93.1775 199.46 93.4118 203.263 93.18 205.362L100.501 204.026C99.4888 202.436 98.3262 198.662 97.2722 194.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.829 454.984C418.353 449.587 409.041 466.212 420.738 475.03C420.738 475.03 437.693 485.606 438.162 488.174C437.69 485.589 449.82 469.724 449.82 469.724C457.624 457.374 443.155 445.152 434.316 454.097C433.924 450.108 433.69 446.306 433.922 444.206L426.6 445.542C427.613 447.132 428.775 450.906 429.829 454.984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1691 99.5827L85.8648 100.916L74.8368 122.486L71.3832 103.558L65.4763 104.636L73.4612 148.398L79.3682 147.32L75.961 128.647L96.708 144.156L104.647 142.708L80.3241 124.503L93.1691 99.5827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.932 549.986L441.237 548.653L452.265 527.083L455.718 546.011L461.625 544.933L453.64 501.17L447.733 502.248L451.141 520.922L430.394 505.412L422.454 506.861L446.777 525.065L433.932 549.986Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 414.647,
    y: 57.3299,
    width: 351.104,
    height: 541.569,
    rx: 17.3693,
    transform: "rotate(10.4596 414.647 57.3299)",
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.614,
    y: 131.378,
    width: 223.975,
    height: 414.44,
    rx: 11.9129,
    transform: "rotate(10.4596 465.614 131.378)",
    fill: "#A385FF",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.619 157.929C439.207 156.51 440.353 154.573 440.77 152.316C441.768 146.907 438.193 141.712 432.783 140.714C427.374 139.715 422.179 143.291 421.181 148.7C420.768 150.936 421.137 153.136 422.094 155.017C421.676 154.881 421.244 154.77 420.799 154.688C415.39 153.69 410.195 157.265 409.197 162.675C408.198 168.084 411.774 173.279 417.183 174.277C419.99 174.795 422.74 174.082 424.875 172.519C423.72 176.909 422.424 181.244 421.341 183.36L428.682 184.715C428.26 182.675 428.611 178.086 429.165 173.427C430.607 175.582 432.884 177.176 435.635 177.684C441.044 178.682 446.239 175.107 447.238 169.697C448.236 164.288 444.661 159.093 439.251 158.095C438.704 157.994 438.158 157.939 437.619 157.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.627 553.04C637.039 554.459 635.893 556.396 635.476 558.652C634.478 564.062 638.053 569.256 643.463 570.255C648.872 571.254 654.067 567.678 655.065 562.269C655.478 560.033 655.109 557.833 654.152 555.952C654.57 556.088 655.002 556.198 655.447 556.281C660.856 557.279 666.051 553.704 667.05 548.294C668.048 542.885 664.473 537.69 659.063 536.692C656.256 536.173 653.506 536.887 651.371 538.45C652.526 534.059 653.823 529.725 654.905 527.609L647.564 526.254C647.986 528.293 647.635 532.882 647.082 537.542C645.64 535.387 643.363 533.793 640.611 533.285C635.202 532.286 630.007 535.862 629.008 541.271C628.01 546.681 631.585 551.875 636.995 552.874C637.542 552.975 638.088 553.029 638.627 553.04Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.815 84.4551L451.514 83.1072L433.545 99.3552L437.038 80.4347L431.133 79.3447L423.057 123.09L428.962 124.18L432.408 105.514L446.295 127.38L454.231 128.845L437.958 103.19L458.815 84.4551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.431 626.514L624.732 627.862L642.701 611.614L639.209 630.534L645.113 631.624L653.189 587.878L647.284 586.788L643.838 605.455L629.951 583.589L622.015 582.123L638.288 607.779L617.431 626.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.257,
    y: 280.57,
    width: 10.0975,
    height: 29.8908,
    rx: 1.24378,
    transform: "rotate(9.25153 624.257 280.57)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.829189,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.574 328.949L586.712 332.15L588.41 281.305L594.056 285.091L599.296 287.983L606.254 289.874L612.149 290.57L615.243 290.607L624.008 318.439L622.14 321.121L619.097 322.899L613.576 324.408L604.455 326.313L595.574 328.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.352 425.227L487.121 429.692L494.281 377.37L474.78 383.763L465.752 386.052L458.998 387.303L454.615 389.617L452.134 392.907L460.204 419.866L470.651 421.169L476.714 422.913L481.352 425.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.671,
    y: 274.085,
    width: 13.5573,
    height: 2.78697,
    rx: 1.24378,
    transform: "rotate(9.25153 623.671 274.085)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.829189,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.721,
    y: 283.843,
    width: 10.0975,
    height: 3.36455,
    transform: "rotate(9.25153 623.721 283.843)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.829189
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.283,
    y: 277.666,
    width: 7.4186,
    height: 2.80548,
    transform: "rotate(9.25153 626.283 277.666)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6092
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.332 140.498C648.688 138.314 650.747 136.831 652.931 137.187C655.115 137.543 656.598 139.602 656.242 141.786L634.477 275.403L626.568 274.115L648.332 140.498Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.332 140.498C648.688 138.314 650.747 136.831 652.931 137.187C655.115 137.543 656.598 139.602 656.242 141.786L634.477 275.403L626.568 274.115L648.332 140.498Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M565.131 241.949C554.755 236.507 544.837 239.004 544.837 239.004C544.837 239.004 558.961 244.977 565.713 256.162",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.885 234.913C563.32 236.002 572.486 239.889 577.533 245.889C581.527 250.633 590.262 263.751 591.489 282.797C592.905 304.793 590.69 323.364 587.554 334.008C585.052 342.498 585.112 350.548 571.319 355.703C561.446 359.391 518.4 345.546 511.157 339.735C502.835 333.054 502.369 331.245 502.209 329.214C502.049 327.18 500.945 304.929 508.509 283.61C514.342 267.165 525.839 246.377 534.623 238.322C542.51 231.082 553.656 232.942 559.885 234.913Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.926 278.436C531.577 289.906 535.034 297.469 535.034 297.469C535.034 297.469 548.379 291.883 551.699 284.15",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.725 277.8C545.346 278.131 547.577 279.541 548.659 281.426",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.891 303.557C532.891 303.557 527.916 294.62 523.363 290.932C522.506 290.237 515.567 301.088 517.285 301.653C524.208 303.939 532.891 303.557 532.891 303.557Z",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.326 302.743L531.255 300.783",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.414 302.253L529.459 298.964",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.306 300.877L528.157 296.761",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.634 297.982L526.813 294.315",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.474 294.047L524.936 292.387",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.137 303.596C535.137 303.596 545.989 300.051 552.402 298.333C553.596 298.014 551.363 311.236 549.509 310.818C542.056 309.135 535.137 303.596 535.137 303.596Z",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.15 305.834L544.2 301.11",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.971 307.076L551.964 299.065",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.568 308.728L552.41 302.85",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.844 309.367L551.671 306.507",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.074 236.257L542.828 230.295",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.472 248.732L539.559 233.014",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.39 268.566C557.969 268.629 556.762 271.82 556.752 273.966C556.735 277.696 559.124 279.78 561.35 280.191C564.219 280.72 565.724 279.484 568.151 276.488C569.882 274.351 568.335 271.979 567.286 271.136C566.425 270.446 564.218 268.467 560.39 268.566Z",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.765 273.743C560.622 274.054 560.326 274.269 559.982 274.272C559.495 274.276 559.097 273.853 559.093 273.328C559.091 273.032 559.214 272.766 559.408 272.59C559.186 272.521 558.956 272.499 558.726 272.531C557.505 272.703 556.725 274.338 556.984 276.182C557.244 278.027 558.444 279.383 559.666 279.211C560.887 279.039 561.667 277.404 561.407 275.56C561.31 274.867 561.08 274.243 560.765 273.743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.819 267.89C532.677 268.202 532.38 268.417 532.036 268.42C531.549 268.424 531.151 268.001 531.147 267.476C531.144 267.18 531.267 266.914 531.463 266.738C531.24 266.669 531.011 266.647 530.781 266.68C529.559 266.851 528.78 268.486 529.039 270.331C529.299 272.175 530.499 273.531 531.721 273.359C532.942 273.187 533.722 271.553 533.462 269.708C533.365 269.015 533.134 268.391 532.819 267.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.482 261.969C559.482 261.969 564.476 260.151 568.334 264.822",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.893 254.812C533.893 254.812 542.174 252.82 544.696 261.408",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.461 262.759C538.894 263.741 540.232 265.244 539.954 266.748C539.192 270.877 535.16 273.261 532.117 273.071C529.075 272.882 528.806 268.86 529.072 266.563C529.354 264.121 530.579 262.402 532.139 261.777C533.958 261.048 536.145 261.858 537.461 262.759Z",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.852 261.854C586.365 264.712 589.608 272.139 590.598 275.853C592.648 283.546 578.995 299.636 576.482 313.253",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.431 305.336C627.431 305.336 631.156 306.266 633.751 304.897C633.751 304.897 635.075 303.123 635.356 300.105C635.634 297.141 634.824 295.416 634.824 295.416C629.015 298.236 620.523 297.848 620.523 297.848L617.497 302.936L627.431 305.336Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.537 305.618C632.537 305.618 634.507 306.642 634.284 311.029C634.143 313.827 632.587 315.354 632.587 315.354C632.587 315.354 630.46 313.338 624.409 311.097C619.522 309.288 616.401 308.712 616.401 308.712C612.892 307.395 612.184 301.729 612.184 301.729C612.184 301.729 622.073 304.006 626.279 305.123C630.094 306.138 632.537 305.618 632.537 305.618Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.687 315.963C631.687 315.963 631.725 317.72 630.095 318.73C627.455 320.364 625.324 320.26 625.324 320.26C621.842 314.669 615.925 312.559 615.925 312.559C615.925 312.559 612.808 309.462 614.451 308.36L616.395 308.719C616.4 308.716 629.557 311.426 631.687 315.963Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.947 331.341C611.467 322.71 619.586 326.134 623.8 318.553",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.738 283.012C591.738 283.012 597.434 290.404 614.804 290.728",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.684 289.178C615.684 289.178 617.29 289.594 618.754 289.621C620.481 289.655 622.115 289.36 622.115 289.36C622.316 295.862 621.005 303.4 619.482 309.136C619.482 309.136 617.297 308.609 616.305 306.459C613.121 299.556 614.283 289.665 615.684 289.178Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.983 354.463C523.607 354.44 521.26 353.939 519.261 352.467C517.848 351.426 517.608 349.393 521.306 349.537C526.581 349.744 530.17 350.84 532.39 351.752C534.987 352.817 537.016 354.009 535.12 354.695",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.983 354.463C523.607 354.44 521.26 353.939 519.261 352.467C517.848 351.426 517.608 349.393 521.306 349.537C526.581 349.744 530.17 350.84 532.39 351.752C534.987 352.817 537.016 354.009 535.12 354.695",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.03 360.628C547.963 360.774 543.634 359.28 541.658 357.685C540.565 356.805 539.579 355.254 542.908 355.409C546.053 355.556 550.172 356.771 552.584 357.515C554.565 358.125 556.101 358.611 557.598 360.021C558.369 360.749 559.013 362.599 556.957 362.532",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.03 360.628C547.963 360.774 543.634 359.28 541.658 357.685C540.565 356.805 539.579 355.254 542.908 355.409C546.053 355.556 550.172 356.771 552.584 357.515C554.565 358.125 556.101 358.611 557.598 360.021C558.369 360.749 559.013 362.599 556.957 362.532",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.075,
    y: 430.415,
    width: 10.0975,
    height: 29.8908,
    rx: 1.24378,
    transform: "rotate(-170.748 452.075 430.415)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.829189,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.657,
    y: 436.899,
    width: 13.5573,
    height: 2.78697,
    rx: 1.24378,
    transform: "rotate(-170.748 452.657 436.899)",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.829189,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.611,
    y: 427.141,
    width: 10.0975,
    height: 3.36455,
    transform: "rotate(-170.748 452.611 427.141)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.829189
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.049,
    y: 433.316,
    width: 7.4186,
    height: 2.80548,
    transform: "rotate(-170.748 450.049 433.316)",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.6092
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428 570.485C427.644 572.669 425.585 574.151 423.401 573.795C421.217 573.44 419.734 571.381 420.09 569.196L441.855 435.579L449.764 436.867L428 570.485Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428 570.485C427.644 572.669 425.585 574.151 423.401 573.795C421.217 573.44 419.734 571.381 420.09 569.196L441.855 435.579L449.764 436.867L428 570.485Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.197 469.036C521.574 474.478 531.492 471.981 531.492 471.981C531.492 471.981 517.367 466.007 510.616 454.823",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.443 476.071C513.009 474.982 503.843 471.095 498.795 465.095C494.801 460.351 486.067 447.233 484.839 428.187C483.423 406.191 485.638 387.621 488.774 376.976C491.277 368.486 491.216 360.437 505.009 355.282C514.883 351.594 557.928 365.438 565.171 371.25C573.493 377.93 573.959 379.739 574.12 381.77C574.279 383.805 575.383 406.055 567.82 427.375C561.986 443.82 550.49 464.607 541.706 472.663C533.818 479.902 522.673 478.043 516.443 476.071Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.402 432.549C544.751 421.079 541.294 413.516 541.294 413.516C541.294 413.516 527.949 419.101 524.629 426.835",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.603 433.184C530.982 432.854 528.751 431.444 527.669 429.559",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.437 407.427C543.437 407.427 548.412 416.364 552.965 420.052C553.822 420.747 560.761 409.896 559.043 409.331C552.12 407.045 543.437 407.427 543.437 407.427Z",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.002 408.241L545.073 410.201",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.918 408.729L546.874 412.018",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.022 410.109L548.171 414.225",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.694 413.002L549.515 416.67",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.854 416.938L551.392 418.598",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.191 407.388C541.191 407.388 530.34 410.934 523.926 412.652C522.732 412.971 524.965 399.749 526.82 400.166C534.272 401.849 541.191 407.388 541.191 407.388Z",
    stroke: "black",
    strokeWidth: 1.24288,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.178 405.151L532.128 409.875",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.358 403.908L524.364 411.919",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.761 402.256L523.918 408.134",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.484 401.617L524.657 404.477",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.254 474.727L533.5 480.689",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.856 462.253L536.769 477.97",
    stroke: "black",
    strokeWidth: 0.414294,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.938 442.418C518.359 442.356 519.566 439.164 519.576 437.019C519.593 433.288 517.205 431.205 514.978 430.794C512.11 430.264 510.604 431.5 508.177 434.497C506.446 436.634 507.993 439.005 509.042 439.848C509.903 440.539 512.11 442.517 515.938 442.418Z",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.563 437.24C515.706 436.928 516.002 436.713 516.346 436.71C516.833 436.706 517.231 437.129 517.235 437.655C517.238 437.951 517.114 438.216 516.919 438.392C517.142 438.462 517.372 438.484 517.602 438.451C518.823 438.279 519.603 436.645 519.344 434.8C519.084 432.956 517.884 431.6 516.662 431.772C515.441 431.943 514.661 433.578 514.921 435.423C515.018 436.116 515.249 436.74 515.563 437.24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M543.509 443.097C543.652 442.785 543.948 442.569 544.293 442.566C544.78 442.562 545.178 442.985 545.182 443.51C545.185 443.807 545.061 444.072 544.866 444.248C545.088 444.317 545.318 444.339 545.547 444.307C546.769 444.135 547.548 442.5 547.289 440.656C547.029 438.811 545.829 437.455 544.608 437.627C543.386 437.799 542.606 439.433 542.866 441.278C542.964 441.972 543.194 442.596 543.509 443.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.846 449.015C516.846 449.015 511.852 450.833 507.994 446.162",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.436 456.172C542.436 456.172 534.154 458.164 531.632 449.576",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.867 448.225C537.434 447.243 536.096 445.741 536.374 444.237C537.136 440.107 541.168 437.724 544.211 437.913C547.253 438.103 547.522 442.124 547.256 444.421C546.974 446.864 545.749 448.582 544.189 449.208C542.37 449.936 540.183 449.127 538.867 448.225Z",
    stroke: "black",
    strokeWidth: 0.828588,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.477 449.131C489.963 446.273 486.72 438.845 485.73 435.132C483.68 427.438 497.333 411.348 499.847 397.732",
    stroke: "black",
    strokeWidth: 0.630509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.897 405.648C448.897 405.648 445.172 404.718 442.577 406.087C442.577 406.087 441.253 407.861 440.973 410.88C440.694 413.843 441.504 415.568 441.504 415.568C447.313 412.749 455.806 413.137 455.806 413.137L458.832 408.049L448.897 405.648Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.792 405.365C443.792 405.365 441.822 404.341 442.044 399.953C442.186 397.156 443.741 395.629 443.741 395.629C443.741 395.629 445.868 397.644 451.919 399.885C456.806 401.695 459.927 402.271 459.927 402.271C463.436 403.587 464.145 409.254 464.145 409.254C464.145 409.254 454.255 406.977 450.05 405.86C446.234 404.845 443.792 405.365 443.792 405.365Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.641 395.022C444.641 395.022 444.603 393.265 446.234 392.254C448.873 390.621 451.004 390.724 451.004 390.724C454.486 396.316 460.403 398.426 460.403 398.426C460.403 398.426 463.52 401.522 461.877 402.624L459.933 402.265C459.928 402.269 446.772 399.559 444.641 395.022Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.381 379.643C464.861 388.274 456.742 384.85 452.528 392.432",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59 427.973C484.59 427.973 478.894 420.58 461.524 420.257",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.64 421.804C460.64 421.804 459.035 421.389 457.57 421.361C455.843 421.327 454.209 421.622 454.209 421.622C454.008 415.121 455.319 407.582 456.842 401.846C456.842 401.846 459.027 402.373 460.019 404.524C463.203 411.427 462.041 421.318 460.64 421.804Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25631,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.917969,
    y: 5.56055,
    width: 493.265,
    height: 646.448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 270.096,
    y: 71.6893,
    width: 72.3343,
    height: 183.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.41513
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 270.096,
    y: 71.6893,
    width: 72.3343,
    height: 183.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.41513
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 183.088,
    y: 387.689,
    width: 72.3342,
    height: 183.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.41513
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 183.088,
    y: 387.689,
    width: 72.3342,
    height: 183.101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.41513
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.639216 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 275,
    y: 36,
    width: 494.247,
    height: 646.969,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -16,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 611.006,
    y: 120.982,
    width: 61.4395,
    height: 169.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.788235 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 611.006,
    y: 120.982,
    width: 61.4395,
    height: 169.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.788235 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 403.885,
    y: 420.019,
    width: 61.4395,
    height: 169.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.788235 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 403.885,
    y: 420.019,
    width: 61.4395,
    height: 169.982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78032
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.788235 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokerCards);
export default __webpack_public_path__ + "static/media/PokerCards.4c3300d119aaa6c49a323ec1edb63b24.svg";
export { ForwardRef as ReactComponent };